import React from 'react';
import { cn } from '../../../utils/classnames';

const IconButton = ({ icon: Icon, className = '', ...props }) => {
  return (
    <button
      className={cn(
        'w-8 h-8 rounded-full border border-bluePale flex items-center justify-center bg-white text-blueMedium shrink-0',
        'hover:bg-blueExtraLight transition-colors duration-200',
        className
      )}
      {...props}
    >
      {Icon && <Icon size={16} strokeWidth={2.25} />}
    </button>
  );
};

export default IconButton;
